/**
 * @generated SignedSource<<7a9167c315a11d046c0bff38f5b70b15>>
 * @relayHash a6d262fd516bfd241640743526134aa7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6426981365f88cebe6177665244f3e9579877c2fd53a467b8e33e2dc13ac27ce

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceCommentLevel = "REPLY" | "TOP_LEVEL" | "%future added value";
export type ConfluenceSchedulePublishedType = "PUBLISHED" | "SCHEDULED" | "UNSCHEDULED" | "%future added value";
export type ConfluenceSubscriptionContentType = "BLOGPOST" | "COMMENT" | "DATABASE" | "EMBED" | "FOLDER" | "PAGE" | "WHITEBOARD" | "%future added value";
export type ConfluenceWorkflowApplicationChangeType = "CREATED" | "REMOVED" | "UPDATED" | "%future added value";
export type SubscriptionsContextProviderSubscription$variables = {
  id: string;
};
export type SubscriptionsContextProviderSubscription$data = {
  readonly confluence_onContentModified: {
    readonly __typename: "ConfluenceContentModified";
    readonly _deltas: ReadonlyArray<string> | null;
    readonly accountId: string | null;
    readonly commentCreated: {
      readonly __typename: "ConfluenceCommentCreated";
      readonly adfBodyContent: string | null;
      readonly commentId: string | null;
      readonly pageCommentType: ConfluenceCommentLevel | null;
    } | null;
    readonly commentDeleted: {
      readonly __typename: "ConfluenceCommentUpdated";
      readonly commentId: string | null;
    } | null;
    readonly commentReopened: {
      readonly __typename: "ConfluenceCommentUpdated";
      readonly commentId: string | null;
    } | null;
    readonly commentResolved: {
      readonly __typename: "ConfluenceCommentCreated";
      readonly adfBodyContent: string | null;
      readonly commentId: string | null;
      readonly pageCommentType: ConfluenceCommentLevel | null;
      readonly replies: ReadonlyArray<string> | null;
    } | null;
    readonly commentUpdated: {
      readonly __typename: "ConfluenceCommentUpdated";
      readonly commentId: string | null;
    } | null;
    readonly contentAccessDecisionMade: {
      readonly __typename: "ConfluenceContentAccessDecisionMade";
      readonly contentId: string | null;
      readonly decision: string | null;
    } | null;
    readonly contentAccessRequested: {
      readonly __typename: "ConfluenceContentAccessRequested";
      readonly contentId: string | null;
    } | null;
    readonly contentRestrictionUpdated: {
      readonly __typename: "ConfluenceContentRestrictionUpdated";
      readonly contentId: string | null;
    } | null;
    readonly contentStateDeleted: {
      readonly __typename: "ConfluenceContentPropertyDeleted";
      readonly key: string | null;
    } | null;
    readonly contentStateUpdated: {
      readonly __typename: "ConfluenceContentPropertyUpdated";
      readonly key: string | null;
      readonly value: string | null;
      readonly version: number | null;
    } | null;
    readonly contentUpdatedWithTemplate: {
      readonly __typename: "ConfluenceContentUpdatedWithTemplate";
      readonly spaceKey: string | null;
      readonly subtype: string | null;
    } | null;
    readonly coverPictureDeleted: {
      readonly __typename: "ConfluenceContentPropertyDeleted";
      readonly key: string | null;
    } | null;
    readonly coverPictureUpdated: {
      readonly __typename: "ConfluenceContentPropertyUpdated";
      readonly key: string | null;
      readonly value: string | null;
      readonly version: number | null;
    } | null;
    readonly coverPictureWidthUpdated: {
      readonly __typename: "ConfluenceCoverPictureWidthUpdated";
      readonly coverPictureWidth: string | null;
    } | null;
    readonly editorInlineCommentCreated: {
      readonly __typename: "ConfluenceInlineCommentCreated";
      readonly adfBodyContent: string | null;
      readonly commentId: string | null;
      readonly inlineCommentType: ConfluenceCommentLevel | null;
      readonly markerRef: string | null;
    } | null;
    readonly embedUpdated: {
      readonly __typename: "ConfluenceEmbedUpdated";
      readonly isBlankStateUpdate: boolean | null;
      readonly product: string | null;
    } | null;
    readonly emojiTitleDeleted: {
      readonly __typename: "ConfluenceContentPropertyDeleted";
      readonly key: string | null;
    } | null;
    readonly emojiTitleUpdated: {
      readonly __typename: "ConfluenceContentPropertyUpdated";
      readonly key: string | null;
      readonly value: string | null;
      readonly version: number | null;
    } | null;
    readonly id: string;
    readonly inlineCommentCreated: {
      readonly __typename: "ConfluenceInlineCommentCreated";
      readonly adfBodyContent: string | null;
      readonly commentId: string | null;
      readonly inlineCommentType: ConfluenceCommentLevel | null;
      readonly markerRef: string | null;
    } | null;
    readonly inlineCommentDeleted: {
      readonly __typename: "ConfluenceInlineCommentDeleted";
      readonly commentId: string | null;
      readonly inlineCommentType: ConfluenceCommentLevel | null;
      readonly markerRef: string | null;
    } | null;
    readonly inlineCommentReattached: {
      readonly __typename: "ConfluenceInlineCommentReattached";
      readonly commentId: string | null;
      readonly markerRef: string | null;
      readonly publishVersionNumber: number | null;
      readonly step: {
        readonly __typename: "ConfluenceInlineCommentStep";
        readonly from: number | null;
        readonly mark: {
          readonly __typename: "ConfluenceInlineCommentStepMark";
          readonly attrs: {
            readonly __typename: "ConfluenceInlineCommentStepMarkAttrs";
            readonly annotationType: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly inlineCommentResolved: {
      readonly __typename: "ConfluenceInlineCommentResolved";
      readonly commentId: string | null;
      readonly inlineResolveProperties: {
        readonly __typename: "ConfluenceInlineCommentResolveProperties";
        readonly isDangling: boolean | null;
        readonly resolved: boolean | null;
        readonly resolvedByDangling: boolean | null;
        readonly resolvedFriendlyDate: string | null;
        readonly resolvedTime: string | null;
        readonly resolvedUser: string | null;
      } | null;
      readonly inlineText: string | null;
      readonly markerRef: string | null;
      readonly replies: ReadonlyArray<string> | null;
    } | null;
    readonly inlineCommentUnresolved: {
      readonly __typename: "ConfluenceInlineCommentUpdated";
      readonly commentId: string | null;
      readonly markerRef: string | null;
    } | null;
    readonly inlineCommentUpdated: {
      readonly __typename: "ConfluenceInlineCommentUpdated";
      readonly commentId: string | null;
      readonly markerRef: string | null;
    } | null;
    readonly originTabId: string | null;
    readonly pageBlogified: {
      readonly __typename: "ConfluencePageBlogified";
      readonly blogTitle: string | null;
      readonly converterDisplayName: string | null;
      readonly spaceKey: string | null;
      readonly spaceName: string | null;
    } | null;
    readonly pageMigrated: {
      readonly __typename: "ConfluencePageMigrated";
      readonly fabricEligibility: string | null;
    } | null;
    readonly pageMoved: {
      readonly __typename: "ConfluencePageMoved";
      readonly newSpaceAlias: string | null;
      readonly newSpaceKey: string | null;
      readonly oldParentId: string | null;
      readonly oldPosition: number | null;
      readonly oldSpaceAlias: string | null;
      readonly oldSpaceKey: string | null;
    } | null;
    readonly pageTitlePropertyUpdated: {
      readonly __typename: "ConfluenceContentPropertyUpdated";
      readonly key: string | null;
      readonly value: string | null;
      readonly version: number | null;
    } | null;
    readonly pageUpdated: {
      readonly __typename: "ConfluencePageUpdated";
      readonly confVersion: number | null;
      readonly trigger: string | null;
    } | null;
    readonly rendererInlineCommentCreated: {
      readonly __typename: "ConfluenceRendererInlineCommentCreated";
      readonly adfBodyContent: string | null;
      readonly commentId: string | null;
      readonly inlineCommentType: ConfluenceCommentLevel | null;
      readonly markerRef: string | null;
      readonly publishVersionNumber: number | null;
      readonly step: {
        readonly __typename: "ConfluenceInlineCommentStep";
        readonly from: number | null;
        readonly mark: {
          readonly __typename: "ConfluenceInlineCommentStepMark";
          readonly attrs: {
            readonly __typename: "ConfluenceInlineCommentStepMarkAttrs";
            readonly annotationType: string | null;
          } | null;
        } | null;
        readonly pos: number | null;
        readonly to: number | null;
      } | null;
    } | null;
    readonly schedulePublished: {
      readonly __typename: "ConfluenceSchedulePublished";
      readonly confVersion: number | null;
      readonly eventType: ConfluenceSchedulePublishedType | null;
      readonly publishTime: string | null;
    } | null;
    readonly type: ConfluenceSubscriptionContentType;
    readonly workflowApplicationChanged: {
      readonly __typename: "ConfluenceWorkflowApplicationChanged";
      readonly changeType: ConfluenceWorkflowApplicationChangeType | null;
      readonly contentId: string | null;
      readonly contentStatus: string | null;
      readonly newWorkflowStatusId: string | null;
      readonly version: number | null;
    } | null;
  } | null;
};
export type SubscriptionsContextProviderSubscription = {
  response: SubscriptionsContextProviderSubscription$data;
  variables: SubscriptionsContextProviderSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "kind": "ScalarField",
  "name": "key"
},
v3 = {
  "kind": "ScalarField",
  "name": "version"
},
v4 = [
  (v2/*: any*/),
  {
    "kind": "ScalarField",
    "name": "value"
  },
  (v3/*: any*/),
  (v1/*: any*/)
],
v5 = [
  (v2/*: any*/),
  (v1/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "spaceKey"
},
v7 = {
  "kind": "ScalarField",
  "name": "contentId"
},
v8 = [
  (v7/*: any*/),
  (v1/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "confVersion"
},
v10 = {
  "kind": "ScalarField",
  "name": "commentId"
},
v11 = {
  "kind": "ScalarField",
  "name": "inlineCommentType"
},
v12 = {
  "kind": "ScalarField",
  "name": "adfBodyContent"
},
v13 = {
  "kind": "ScalarField",
  "name": "markerRef"
},
v14 = {
  "kind": "ScalarField",
  "name": "publishVersionNumber"
},
v15 = {
  "kind": "ScalarField",
  "name": "from"
},
v16 = {
  "kind": "ScalarField",
  "name": "annotationType"
},
v17 = [
  (v10/*: any*/),
  (v13/*: any*/),
  (v1/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "name": "replies"
},
v19 = {
  "kind": "ScalarField",
  "name": "pageCommentType"
},
v20 = [
  (v1/*: any*/),
  (v10/*: any*/)
],
v21 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ConfluenceContentModified",
    "kind": "LinkedField",
    "name": "confluence_onContentModified",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "accountId"
      },
      {
        "kind": "ScalarField",
        "name": "originTabId"
      },
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "_deltas"
      },
      {
        "concreteType": "ConfluenceContentPropertyUpdated",
        "kind": "LinkedField",
        "name": "contentStateUpdated",
        "plural": false,
        "selections": (v4/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentPropertyUpdated",
        "kind": "LinkedField",
        "name": "emojiTitleUpdated",
        "plural": false,
        "selections": (v4/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentPropertyUpdated",
        "kind": "LinkedField",
        "name": "coverPictureUpdated",
        "plural": false,
        "selections": (v4/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentPropertyUpdated",
        "kind": "LinkedField",
        "name": "pageTitlePropertyUpdated",
        "plural": false,
        "selections": (v4/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentPropertyDeleted",
        "kind": "LinkedField",
        "name": "coverPictureDeleted",
        "plural": false,
        "selections": (v5/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentPropertyDeleted",
        "kind": "LinkedField",
        "name": "emojiTitleDeleted",
        "plural": false,
        "selections": (v5/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentPropertyDeleted",
        "kind": "LinkedField",
        "name": "contentStateDeleted",
        "plural": false,
        "selections": (v5/*: any*/)
      },
      {
        "concreteType": "ConfluenceCoverPictureWidthUpdated",
        "kind": "LinkedField",
        "name": "coverPictureWidthUpdated",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "coverPictureWidth"
          },
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluencePageBlogified",
        "kind": "LinkedField",
        "name": "pageBlogified",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "spaceName"
          },
          {
            "kind": "ScalarField",
            "name": "blogTitle"
          },
          {
            "kind": "ScalarField",
            "name": "converterDisplayName"
          },
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceEmbedUpdated",
        "kind": "LinkedField",
        "name": "embedUpdated",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "product"
          },
          {
            "kind": "ScalarField",
            "name": "isBlankStateUpdate"
          },
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluencePageMigrated",
        "kind": "LinkedField",
        "name": "pageMigrated",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "fabricEligibility"
          },
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceContentRestrictionUpdated",
        "kind": "LinkedField",
        "name": "contentRestrictionUpdated",
        "plural": false,
        "selections": (v8/*: any*/)
      },
      {
        "concreteType": "ConfluencePageMoved",
        "kind": "LinkedField",
        "name": "pageMoved",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "oldSpaceKey"
          },
          {
            "kind": "ScalarField",
            "name": "newSpaceKey"
          },
          {
            "kind": "ScalarField",
            "name": "oldParentId"
          },
          {
            "kind": "ScalarField",
            "name": "oldPosition"
          },
          {
            "kind": "ScalarField",
            "name": "newSpaceAlias"
          },
          {
            "kind": "ScalarField",
            "name": "oldSpaceAlias"
          },
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluencePageUpdated",
        "kind": "LinkedField",
        "name": "pageUpdated",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "trigger"
          },
          (v9/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceWorkflowApplicationChanged",
        "kind": "LinkedField",
        "name": "workflowApplicationChanged",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "name": "changeType"
          },
          {
            "kind": "ScalarField",
            "name": "newWorkflowStatusId"
          },
          {
            "kind": "ScalarField",
            "name": "contentStatus"
          },
          (v3/*: any*/),
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceContentUpdatedWithTemplate",
        "kind": "LinkedField",
        "name": "contentUpdatedWithTemplate",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "subtype"
          },
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceInlineCommentCreated",
        "kind": "LinkedField",
        "name": "inlineCommentCreated",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v1/*: any*/),
          (v13/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceRendererInlineCommentCreated",
        "kind": "LinkedField",
        "name": "rendererInlineCommentCreated",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v10/*: any*/),
          (v12/*: any*/),
          (v11/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "concreteType": "ConfluenceInlineCommentStep",
            "kind": "LinkedField",
            "name": "step",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "kind": "ScalarField",
                "name": "to"
              },
              {
                "kind": "ScalarField",
                "name": "pos"
              },
              {
                "concreteType": "ConfluenceInlineCommentStepMark",
                "kind": "LinkedField",
                "name": "mark",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                    "kind": "LinkedField",
                    "name": "attrs",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v1/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              (v1/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "ConfluenceInlineCommentCreated",
        "kind": "LinkedField",
        "name": "editorInlineCommentCreated",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v13/*: any*/),
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceInlineCommentUpdated",
        "kind": "LinkedField",
        "name": "inlineCommentUpdated",
        "plural": false,
        "selections": (v17/*: any*/)
      },
      {
        "concreteType": "ConfluenceInlineCommentDeleted",
        "kind": "LinkedField",
        "name": "inlineCommentDeleted",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v13/*: any*/),
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceInlineCommentResolved",
        "kind": "LinkedField",
        "name": "inlineCommentResolved",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "concreteType": "ConfluenceInlineCommentResolveProperties",
            "kind": "LinkedField",
            "name": "inlineResolveProperties",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isDangling"
              },
              {
                "kind": "ScalarField",
                "name": "resolved"
              },
              {
                "kind": "ScalarField",
                "name": "resolvedByDangling"
              },
              {
                "kind": "ScalarField",
                "name": "resolvedFriendlyDate"
              },
              {
                "kind": "ScalarField",
                "name": "resolvedTime"
              },
              {
                "kind": "ScalarField",
                "name": "resolvedUser"
              },
              (v1/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "inlineText"
          },
          (v13/*: any*/),
          (v18/*: any*/),
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceInlineCommentUpdated",
        "kind": "LinkedField",
        "name": "inlineCommentUnresolved",
        "plural": false,
        "selections": (v17/*: any*/)
      },
      {
        "concreteType": "ConfluenceInlineCommentReattached",
        "kind": "LinkedField",
        "name": "inlineCommentReattached",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v1/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "concreteType": "ConfluenceInlineCommentStep",
            "kind": "LinkedField",
            "name": "step",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "concreteType": "ConfluenceInlineCommentStepMark",
                "kind": "LinkedField",
                "name": "mark",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                    "kind": "LinkedField",
                    "name": "attrs",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v16/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              (v1/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "ConfluenceCommentCreated",
        "kind": "LinkedField",
        "name": "commentCreated",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v12/*: any*/),
          (v10/*: any*/),
          (v19/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceCommentUpdated",
        "kind": "LinkedField",
        "name": "commentUpdated",
        "plural": false,
        "selections": (v20/*: any*/)
      },
      {
        "concreteType": "ConfluenceCommentUpdated",
        "kind": "LinkedField",
        "name": "commentDeleted",
        "plural": false,
        "selections": (v20/*: any*/)
      },
      {
        "concreteType": "ConfluenceCommentCreated",
        "kind": "LinkedField",
        "name": "commentResolved",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v12/*: any*/),
          (v10/*: any*/),
          (v19/*: any*/),
          (v18/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceCommentUpdated",
        "kind": "LinkedField",
        "name": "commentReopened",
        "plural": false,
        "selections": (v20/*: any*/)
      },
      {
        "concreteType": "ConfluenceSchedulePublished",
        "kind": "LinkedField",
        "name": "schedulePublished",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "publishTime"
          },
          {
            "kind": "ScalarField",
            "name": "eventType"
          },
          (v9/*: any*/),
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceContentAccessRequested",
        "kind": "LinkedField",
        "name": "contentAccessRequested",
        "plural": false,
        "selections": (v8/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentAccessDecisionMade",
        "kind": "LinkedField",
        "name": "contentAccessDecisionMade",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "name": "decision"
          },
          (v1/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SubscriptionsContextProviderSubscription",
    "selections": (v21/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionsContextProviderSubscription",
    "selections": (v21/*: any*/)
  },
  "params": {
    "cacheID": "a6d262fd516bfd241640743526134aa7",
    "id": "6426981365f88cebe6177665244f3e9579877c2fd53a467b8e33e2dc13ac27ce",
    "metadata": {},
    "name": "SubscriptionsContextProviderSubscription",
    "operationKind": "subscription",
    "text": "subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,accountId,originTabId,__typename,_deltas,contentStateUpdated{key,value,version,__typename},emojiTitleUpdated{key,value,version,__typename},coverPictureUpdated{key,value,version,__typename},pageTitlePropertyUpdated{key,value,version,__typename},coverPictureDeleted{key,__typename},emojiTitleDeleted{key,__typename},contentStateDeleted{key,__typename},coverPictureWidthUpdated{coverPictureWidth,__typename},pageBlogified{spaceKey,spaceName,blogTitle,converterDisplayName,__typename},embedUpdated{product,isBlankStateUpdate,__typename},pageMigrated{fabricEligibility,__typename},contentRestrictionUpdated{contentId,__typename},pageMoved{oldSpaceKey,newSpaceKey,oldParentId,oldPosition,newSpaceAlias,oldSpaceAlias,__typename},pageUpdated{__typename,trigger,confVersion},workflowApplicationChanged{contentId,changeType,newWorkflowStatusId,contentStatus,version,__typename},contentUpdatedWithTemplate{spaceKey,subtype,__typename},inlineCommentCreated{commentId,inlineCommentType,adfBodyContent,__typename,markerRef},rendererInlineCommentCreated{__typename,commentId,adfBodyContent,inlineCommentType,markerRef,publishVersionNumber,step{from,to,pos,mark{attrs{annotationType,__typename},__typename},__typename}},editorInlineCommentCreated{adfBodyContent,commentId,inlineCommentType,markerRef,__typename},inlineCommentUpdated{commentId,markerRef,__typename},inlineCommentDeleted{commentId,inlineCommentType,markerRef,__typename},inlineCommentResolved{commentId,inlineResolveProperties{isDangling,resolved,resolvedByDangling,resolvedFriendlyDate,resolvedTime,resolvedUser,__typename},inlineText,markerRef,replies,__typename},inlineCommentUnresolved{commentId,markerRef,__typename},inlineCommentReattached{commentId,__typename,markerRef,publishVersionNumber,step{from,mark{attrs{__typename,annotationType},__typename},__typename}},commentCreated{__typename,adfBodyContent,commentId,pageCommentType},commentUpdated{__typename,commentId},commentDeleted{__typename,commentId},commentResolved{__typename,adfBodyContent,commentId,pageCommentType,replies},commentReopened{__typename,commentId},schedulePublished{publishTime,eventType,confVersion,__typename},contentAccessRequested{contentId,__typename},contentAccessDecisionMade{contentId,decision,__typename}}}"
  }
};
})();

(node as any).hash = "5f32fea86d09ae215d5698e5715124ed";

export default node;
